import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'Address';
const ENDPOINT = `/addresses/`;

@Injectable({
    providedIn: 'root'
})
export class AddressService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
